/**
 * HR-rollen: de ene lijst waar de rolbepaling, de rolvergelijkingen en de
 * runtime-validatie alle drie op leunen.
 *
 * Achtergrond: `user_roles` in `xxtractdb03` is een gedeelde tabel van vier
 * applicaties (HR-portal, OpsCenter, rittenplanner, proposal). De rolnaam
 * `admin` bestaat drie keer in de catalogus `roles`, met een andere `app`. De
 * HR-portal telt alleen rijen mee waarvan `roles.app = 'hr'`, en beslist bij
 * meer dan één HR-rij met de rangorde hieronder.
 *
 * Spec: _bmad-output/implementation-artifacts/spec-fix-rolbepaling-app-scope.md,
 * sectie "Rangorde van de HR-rollen".
 */
/** De waarde van `roles.app` waarmee de HR-portal zijn eigen rijen herkent. */
export const HR_APP = 'hr';
/**
 * De rangorde, van ruimst naar smalst. Dit is een expliciete lijst van
 * rolnamen — bewust niet een sortering op `role_id`. Dat de nummers 1-2-3-4
 * vandaag toevallig gelijklopen is een samenloop, geen afspraak: een nieuwe
 * HR-rol krijgt straks `role_id` 18 en hoort dan niet automatisch de smalste
 * te zijn.
 *
 * Een naam die hier niet in staat, is geen HR-rol: hij telt niet mee bij het
 * kiezen van de smalste en leidt tot de terugval, niet tot toegang.
 */
export const HR_ROLE_RANK = ['admin', 'hr', 'beoordelaar', 'medewerker'];
/** De rol waarop iemand zonder geldige HR-rij terugvalt: alleen zichzelf. */
export const HR_ROLE_FALLBACK = 'medewerker';
/** Rangnummer in de rangorde: 0 = ruimst (`admin`), 3 = smalst (`medewerker`). */
export function hrRoleRank(role) {
    return HR_ROLE_RANK.indexOf(role);
}
/** Type guard: is dit een van de vier HR-rolnamen? Hoofdlettergevoelig, geen trim. */
export function isKnownHrRole(value) {
    return typeof value === 'string' && HR_ROLE_RANK.includes(value);
}
/**
 * Kiest uit een verzameling rolnamen de SMALSTE HR-rol volgens de rangorde.
 * Namen buiten de rangorde worden genegeerd. Onafhankelijk van de volgorde
 * van de invoer: de uitkomst komt uit de lijst, niet uit "de eerste rij".
 *
 * @returns de smalste bekende HR-rol, of `null` als er geen bekende rol bij zit
 */
export function narrowestHrRole(names) {
    let narrowest = null;
    for (const name of names) {
        if (!isKnownHrRole(name))
            continue;
        if (narrowest === null || hrRoleRank(name) > hrRoleRank(narrowest)) {
            narrowest = name;
        }
    }
    return narrowest;
}
//# sourceMappingURL=hrRoles.js.map